<full-header-slider class="block relative w-full lg:mt-[-86px]">
  <div class="container lg:pt-[215px] w-full pb-8 flex flex-col items-center text-white">
    <h1 class="text-4xl mb-2 lg:mt-5 place-self-start" i18n="recent event title">Upcoming events in the metalworking industry</h1>
    <h3 class="text-2xl mb-10 place-self-start" i18n="recent event subtitle">Keep in the loop with all the upcoming international events for your reference field</h3>
    <block-horizontal class="w-full h-[265px] mb-3"
      [pageSize]="3"
      [itemWidth]="400"
      [itemHeight]="265"
      [colGap]="20"
      [itemTpl]="recentEventsScrollerTpl"
      [renderOnTimeOut]="0"
      [itemsQuery]="recentEventsQuery">
    </block-horizontal>
    <ng-template let-item let-index="index" #recentEventsScrollerTpl>
      <event-block
        class="w-[290px] h-[192px] md:w-[400px] md:h-[265px]"
        #eventBlock
        [portalEvent]="item"
        [imageSizes]="[{ w: 400, h: 225, resizeMode: 'fill' }]">
        <card-edit-bar
        *renderIf="{roles:[UserRolesEnum.admin]}"
        [show]="eventBlock.hovered"
        (edit)="editEvent(item)"
        (softDelete)="softDeletePortalEvent(item)"
        i18n-editTooltip editTooltip="edit event"
        i18n-deleteTooltip deleteTooltip="delete event"
        i18n-deleteMsg deleteMsg="Do you really want to delete this event?">
      </card-edit-bar>
      </event-block>
    </ng-template>
  </div>
</full-header-slider>



